
import eventsource from "../../lib/plugin/eventsource.js"

eventsource(window._hyperscript)

